// Catálogo de Equipamentos para Locação - WellTec
// Equipamentos atualmente disponíveis na Home

const equipments = [
  // LAVADORAS DE PISO
  {
    id: 'lavadora-as510',
    category: 'lavadora',
    manufacturer: 'AS',
    model: '510',
    description: 'Lavadora e secadora de pisos média, robusta e fácil de usar, ideal para limpeza diária de áreas internas com tráfego médio a intenso',
    mainImage: 'https://images.squarespace-cdn.com/content/v1/6944bce717735870c92588a9/1769487042490-M231VKMH28PY4LYYRDOG/Screenshot_7.jpg',
    specifications: {
      type: 'Lavadora e secadora de pisos',
      cleaningWidth: '510 mm',
      solutionTank: '40 L',
      recoveryTank: '40 L',
      productivity: 'Até 2.100 m²/h',
      power: 'Bateria',
      features: [
        'Robusta e durável',
        'Fácil de usar',
        'Ideal para tráfego médio a intenso',
        'Limpeza diária eficiente'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/66e704f2145da178_NILFISK%20AS510.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  },
  {
    id: 'lavadora-sc450',
    category: 'lavadora',
    manufacturer: 'SC',
    model: '450',
    description: 'Lavadora e secadora de pisos compacta e fácil de usar, ideal para limpeza diária de ambientes comerciais e industriais',
    mainImage: 'https://images.squarespace-cdn.com/content/v1/6944bce717735870c92588a9/1769487229177-AI3NAI2HDSZSQDZEQ7GD/SC450_masked.jpg',
    specifications: {
      type: 'Lavadora e secadora compacta',
      cleaningWidth: '530 mm',
      solutionTank: '40 L',
      recoveryTank: '45 L',
      productivity: 'Até 2.120 m²/h',
      power: 'Bateria',
      features: [
        'Design compacto',
        'Fácil operação',
        'Uso comercial e industrial',
        'Limpeza diária'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/83d8464a906377ef_NILFISK%20SC450.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  },
  {
    id: 'lavadora-platinum-lst51',
    category: 'lavadora',
    manufacturer: 'Platinum',
    model: 'LST-51',
    description: 'Lavadora automática de pisos robusta, semitracionária e de operação simples, projetada para limpeza profissional de áreas de tráfego médio',
    mainImage: 'https://images.squarespace-cdn.com/content/v1/6944bce717735870c92588a9/1769487407430-IQCHK8JP6ER7SDWRMY47/Screenshot_8.jpg',
    specifications: {
      type: 'Lavadora semitracionária',
      cleaningWidth: '510 mm',
      solutionTank: '48 L',
      recoveryTank: '48 L',
      productivity: 'Até 1.700 m²/h',
      power: 'Bateria',
      features: [
        'Robusta e durável',
        'Semitracionária',
        'Operação simples',
        'Limpeza profissional'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/89afd55a08f75b15_NILFISK%20LST-51.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  },
  {
    id: 'lavadora-fimap-mr85',
    category: 'lavadora',
    manufacturer: 'Fimap',
    model: 'MR85',
    description: 'Lavadora automática de alto desempenho com tecnologia italiana, ideal para grandes áreas industriais e comerciais',
    mainImage: 'https://www.fimap.com/assets/repository/img/macchine/modelli/mr_75_disc_2026_entire_fisheye_2000x2000_rgb.jpg',
    specifications: {
      type: 'Lavadora automática tripulada',
      cleaningWidth: '845 mm',
      solutionTank: '110 L',
      recoveryTank: '125 L',
      productivity: 'Até 5.100 m²/h',
      power: 'Bateria',
      features: [
        'Tecnologia italiana',
        'Alto desempenho',
        'Ideal para grandes áreas',
        'Uso industrial e comercial'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/4c33ef236b27d63d_FIMAP%20MR85.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  },
  {
    id: 'lavadora-karcher-b300',
    category: 'lavadora',
    manufacturer: 'Kärcher',
    model: 'B300',
    description: 'Lavadora tripulada de alta produtividade da renomada marca alemã, perfeita para limpeza de grandes espaços',
    mainImage: 'https://d1y4tv7o00gnfq.cloudfront.net/mam/98998970/mainproduct/71392/d0.jpg',
    specifications: {
      type: 'Lavadora tripulada',
      cleaningWidth: '1.045–1.400 mm',
      solutionTank: '300 L',
      recoveryTank: '300 L',
      productivity: 'Até 16.550 m²/h',
      power: 'GLP (Gás)',
      features: [
        'Marca alemã renomada',
        'Alta produtividade',
        'Perfeita para grandes espaços',
        'Design robusto'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/651d6154c686803d_KARCHER%20B300.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  },
  {
    id: 'lavadora-nilfisk-sc6500',
    category: 'lavadora',
    manufacturer: 'Nilfisk',
    model: 'SC6500',
    description: 'Lavadora de alta capacidade com tecnologia escandinava, robusta e eficiente para ambientes desafiadores',
    mainImage: 'https://www.nilfisk.com/product-images-1920/SC6500-Cyl-OL-Rt-ps-Original-JPJHHJP.webp',
    specifications: {
      type: 'Lavadora de alta capacidade',
      cleaningWidth: '1.000 mm',
      solutionTank: '265 L',
      recoveryTank: '265 L',
      productivity: 'Até 11.700 m²/h',
      power: 'Bateria',
      features: [
        'Tecnologia escandinava',
        'Extremamente robusta',
        'Eficiente em ambientes desafiadores',
        'Alta capacidade'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/c06104e75bdef199_NILFISK%20SC6500.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  },
  {
    id: 'lavadora-karcher-bd530',
    category: 'lavadora',
    manufacturer: 'Kärcher',
    model: 'BD530',
    description: 'Lavadora compacta walk-behind da Kärcher, perfeita para áreas de médio porte com alta manobralidade',
    mainImage: 'https://d1y4tv7o00gnfq.cloudfront.net/mam/98408630/mainproduct/48542/d0.jpg',
    specifications: {
      type: 'Lavadora walk-behind',
      cleaningWidth: '460 mm',
      solutionTank: '40 L',
      recoveryTank: '40 L',
      productivity: 'Até 2.040 m²/h',
      power: 'Elétrica/Bateria',
      features: [
        'Design compacto',
        'Alta manobrabilidade',
        'Ideal para áreas médias',
        'Fácil operação'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/83f1acdba639b4d3_KARCHER%20BD530.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  },

  // VARREDEIRAS DE PISO
  {
    id: 'varredeira-tennant-6400',
    category: 'varredeira',
    manufacturer: 'Tennant',
    model: '6400',
    description: 'Varredeira tripulada de alto rendimento, ideal para limpeza de grandes áreas externas e internas com máxima eficiência',
    mainImage: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/ab7c88cb42818a1d_IMG_20260211_210748_723.jpg',
    specifications: {
      type: 'Varredeira tripulada',
      sweepingWidth: '915 mm',
      productivity: 'Até 10.230 m²/h',
      power: 'GLP (Gás)',
      features: [
        'Alto rendimento',
        'Ideal para grandes áreas',
        'Uso externo e interno',
        'Máxima eficiência'
      ]
    },
    pdfUrl: 'https://customer-assets-4nw71qhi.emergentagent.net/job_locacao-pisos/artifacts/cb782c9db66c728b_TENNANT%206400.pdf',
    available: true,
    lastUpdated: '2026-01-10'
  }
];

export default equipments;
